import React from 'react';
import {
  Container,
  ContentWrapper,
  TextColumn,
  ChatColumn,
  QuestionTitle,
  AnswerText,
  DownloadButton,
  ChatInterface,
  ChatHeader,
  AppName,
  TimeDisplay,
  ChatBody,
  ContextLabel,
  ContextDescription,
  MessageBubble,
  MessageText,
  TimeEstimate,
  KeyCorrelations,
  CorrelationText
} from './styles';

const Section5 = () => {
  return (
    <Container>
      <ContentWrapper>
        <TextColumn>
          <QuestionTitle>Contexto, Vocabulário, Verbos e Pronúncia</QuestionTitle>
          <AnswerText>
          Aprenda Inglês na Prática: Contextos Reais + Vocabulário Nativo + Verbos Essenciais + Pronúncia Ideal!<br/><br/>
          Domine o idioma no seu ritmo, via WhatsApp, com desafios diários que preparam você para o mundo real. ✨
          </AnswerText>
          <DownloadButton>Experimente</DownloadButton>
        </TextColumn>
        
        <ChatColumn>
          <ChatInterface>
            <ChatHeader>
              <AppName>FluenciA</AppName>
              <TimeDisplay>Pedir ajuda</TimeDisplay>
            </ChatHeader>
            
            <ChatBody>
              <ContextLabel>Contexto</ContextLabel>
              <ContextDescription>
                Você é o gerente do projeto e precisa cobrar o envio de documentos 
                necessários do cliente de forma educada, mas firme.
              </ContextDescription>
              
              <MessageBubble>
                <MessageText>
                  Dear Mr. Smith, I hope you are well. About the documents, we need it today
                  because the project deadline is approaching. Please send us ASAP.
                  <br /><br />
                  Best regards,<br />
                  Victor.
                </MessageText>
              </MessageBubble>
              
              <TimeEstimate>Tempo estimado da atividade: 5 minutos</TimeEstimate>
              
              <KeyCorrelations>Correlações Chave:</KeyCorrelations>
              <CorrelationText>1- "We need it" → "We've noticed they haven't been submitted!"
                (Mais profissional e menos direto)...
              </CorrelationText>
            </ChatBody>
          </ChatInterface>
        </ChatColumn>
      </ContentWrapper>
    </Container>
  );
};

export default Section5;
